import { Box, Spinner, Stack } from "@adfenix/alexandria";
import Page from "components/Page";
import PageHeader from "components/PageHeader";
import FacebookHqIntegration from "./facebook/facebook-integration";
import { GenericError } from "components/GenericError";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { userSelectedHq } from "atoms/auth";
import { useRecoilValue } from "recoil";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HqAndOfficeIdRouteParams } from "components/SelectHqOfficeCombobox/helper";
import {
  getHqIntegrations,
  getOfficeIntegrations
} from "api/services/configService";

const ChannelIntegration = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedHq = useRecoilValue(userSelectedHq);
  const { hqId, officeId } = useParams<HqAndOfficeIdRouteParams>();

  const {
    data,
    isInitialLoading: isLoading,
    error
  } = useQuery(["getHqIntegrations", hqId], () => getHqIntegrations(hqId!), {
    enabled: Boolean(hqId)
  });

  const {
    data: officeData,
    isInitialLoading: isLoadingOffice,
    error: officeError
  } = useQuery(
    ["getOfficeIntegrations", hqId, officeId],
    () => getOfficeIntegrations(officeId!),
    { enabled: Boolean(hqId && officeId) }
  );

  useEffect(() => {
    if (selectedHq && !officeId) {
      navigate(`/customer/hq/${selectedHq.id}/facebook/integration`);
    }
  }, [hqId, selectedHq, officeId, navigate]);

  if (
    ((isLoading || !data) && officeId == undefined) ||
    isLoadingOffice ||
    (!officeData && officeId)
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Spinner />
      </Box>
    );
  }

  if (error || officeError) return <GenericError />;

  return (
    <Page
      header={
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <PageHeader title={t("selfonboarding.page.header.title")} />
        </Box>
      }
    >
      <br />
      <Stack spacing="m">
        {officeId == undefined && data && (
          <FacebookHqIntegration hqId={hqId!} />
        )}

        {data && officeData && officeId && (
          <FacebookHqIntegration hqId={hqId!} officeId={officeId} />
        )}
      </Stack>
    </Page>
  );
};

export default ChannelIntegration;
